export const BUS_EVENTS = {
  KANBAN_ITEM_CHANGED: 'KANBAN_ITEM_CHANGED',
  // SiteUP (D45/D46): item da Central mudou (ai_center.item.updated) e
  // mensagem nova chegou em tempo real, para a sugestão no chat sumir.
  AI_CENTER_ITEM_UPDATED: 'AI_CENTER_ITEM_UPDATED',
  CONVERSATION_MESSAGE_CREATED: 'CONVERSATION_MESSAGE_CREATED',
  // SiteUP (D50): a sugestão da Central saiu pelo balão na conversa; a do
  // copiloto, que respondia a mesma mensagem do cliente, sai junto.
  AI_CENTER_SUGGESTION_SENT: 'AI_CENTER_SUGGESTION_SENT',
  KANBAN_ITEM_ACCESS_CHANGED: 'KANBAN_ITEM_ACCESS_CHANGED',
  GOOGLE_CALENDAR_ACCESS_CHANGED: 'GOOGLE_CALENDAR_ACCESS_CHANGED',
  SHOW_ALERT: 'SHOW_ALERT',
  START_NEW_CONVERSATION: 'START_NEW_CONVERSATION',
  FOCUS_CUSTOM_ATTRIBUTE: 'FOCUS_CUSTOM_ATTRIBUTE',
  SCROLL_TO_MESSAGE: 'SCROLL_TO_MESSAGE',
  MESSAGE_SENT: 'MESSAGE_SENT',
  ON_MESSAGE_LIST_SCROLL: 'ON_MESSAGE_LIST_SCROLL',
  WEBSOCKET_DISCONNECT: 'WEBSOCKET_DISCONNECT',
  WEBSOCKET_RECONNECT: 'WEBSOCKET_RECONNECT',
  WEBSOCKET_RECONNECT_COMPLETED: 'WEBSOCKET_RECONNECT_COMPLETED',
  INTERNAL_CHAT_MESSAGE_CREATED: 'INTERNAL_CHAT_MESSAGE_CREATED',
  INTERNAL_CHAT_MEMBER_REMOVED: 'INTERNAL_CHAT_MEMBER_REMOVED',
  INTERNAL_CHAT_MESSAGE_UPDATED: 'INTERNAL_CHAT_MESSAGE_UPDATED',
  TOGGLE_REPLY_TO_MESSAGE: 'TOGGLE_REPLY_TO_MESSAGE',
  SHOW_TOAST: 'newToastMessage',
  NEW_CONVERSATION_MODAL: 'newConversationModal',
  INSERT_INTO_RICH_EDITOR: 'insertIntoRichEditor',
  INSERT_INTO_NORMAL_EDITOR: 'insertIntoNormalEditor',
  PREPARE_CONVERSATION_REPLY: 'prepareConversationReply',
  OPEN_WHATSAPP_TEMPLATES: 'openWhatsappTemplates',
  // SiteUp: o menu de tres pontos do celular dispara acoes do composer
  // (emoji, audio, nota, templates) sem repor os botoes na barra de escrever.
  MOBILE_COMPOSER_ACTION: 'MOBILE_COMPOSER_ACTION',
  // SiteUp (Cartoes de Apoio): a bolha da sugestao vive na arvore do MessagesView,
  // e o modal de imoveis mora no ReplyBox. O chip pede a abertura por aqui.
  OPEN_PROPERTY_SUGGESTIONS: 'OPEN_PROPERTY_SUGGESTIONS',
};
